import logo from './logo.svg';
import './App.css';
import frontimage from './assets/image/fontimage2.jpg';
import frontimage2 from './assets/image/frontimage.jpg'
import frontimage3 from './assets/image/test.jpg'
import logotrans from './assets/image/wbstransvit.png';
import facebook from './assets/image/facebook.png';
import instagram from './assets/image/instagram.png';
import sellcar from './assets/image/sellcar.jpg';
import buycar from './assets/image/buycar.jpg';
import home from './assets/image/home.png';
import call from './assets/image/call.png';
import email from './assets/image/email2.png';
import homeicon from './assets/image/homeicon.png';
import about from './assets/image/about.png';
import sell from './assets/image/money.png';
import contact from './assets/image/phone-call.png';
import buy from './assets/image/cart.png';
import swish from './assets/image/swish2.jpg'
import {use, useEffect, useLayoutEffect, useRef, useState} from "react";
import bank from './assets/image/bank.png'

import img1 from './assets/frontimages/thumbnail_IMG_5333.jpg'
import img2 from './assets/frontimages/thumbnail_IMG_5363.jpg'
import img3 from './assets/frontimages/thumbnail_IMG_5393.jpg'
import img4 from './assets/frontimages/thumbnail_IMG_5409.jpg'
import img5 from './assets/frontimages/thumbnail_IMG_5431.jpg'
import img6 from './assets/frontimages/thumbnail_IMG_5660.jpg'
import img7 from './assets/frontimages/thumbnail_IMG_5695.jpg'
import img8 from './assets/frontimages/thumbnail_IMG_5718.jpg'
import img9 from './assets/frontimages/thumbnail_IMG_5751.jpg'
import img10 from './assets/frontimages/thumbnail_IMG_5779.jpg'
import img11 from './assets/frontimages/thumbnail_IMG_6290.jpg'
import img12 from './assets/frontimages/thumbnail_IMG_6318.jpg'
import img13 from './assets/frontimages/thumbnail_IMG_6346.jpg'
import img14 from './assets/frontimages/thumbnail_IMG_6373.jpg'
import img15 from './assets/frontimages/thumbnail_IMG_6403.jpg'
import Policy from "./Policy";

function App() {
    const [buttonSize, setButtonSize] = useState(1);
    const [height, setHeight] = useState(200)
    const frontref = useRef(null)
    const [windowSize, setWindowSize] = useState({
        width: undefined,
        height: undefined,
    });
    const [images, setImages] = useState([img1,img2,img3,img4,img5,img6,img7,img8,img9,img10,img11,img12,img13,img14,img15])
    const [number, setNumber] = useState(0)

    //colors rgba(27,27,27, 1), rgba(0,0,0,.2)

    useEffect(()=>{
        setTimeout(()=>{
            setNumber((number+1) % images.length)
        }, 3000)
    },[number])

    useEffect(() => {
        // Handler to call on window resize

        function handleResize() {
            // Set window width/height to state
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
            setHeight(window.innerWidth*0.75 + 80)
        }
        // Add event listener
        window.addEventListener("resize", handleResize);
        // Call handler right away so state gets updated with initial window size
        handleResize();
        // Remove event listener on cleanup
        //return () => window.removeEventListener("resize", handleResize);
    }, []);

    /*useEffect(() => {
        //setHeight(frontref.current.clientHeight+80)
        console.log(height)
        document.onreadystatechange = () => {
            //setHeight(frontref.current.clientHeight+80)
        }
        setWindowSize({width: widthh, height: heightt})
    },[windowSize.width,widthh])*/
    //},[frontref.current, frontref.current?frontref.current.clientHeight:0])
    function scroll(id){
        const yOffset = -80;
        const element = document.getElementById(id);
        const y = element.getBoundingClientRect().top + window.scrollY + yOffset;
        window.scrollTo({top: y, behavior: 'smooth'});
    }

    return (
        <div style={{overflowX: 'hidden', backgroundColor: '#1b1b1b', zIndex: -3, paddingLeft: 0, paddingRight: 0, position: 'relative', paddingTop: 0, display: 'flex', alignItems: 'center', flexDirection: 'column'}}>

            <div style={{display: 'flex', flexDirection: 'row', width: '100%', height: windowSize.width > 900 ? 80 : 70, backgroundColor: 'rgba(40,40,40, 1)', justifyContent: 'center', position: 'fixed', top: 0, left: 0, zIndex: 100, boxShadow: '0px 1px 30px -5px #0092C8'}}>
                <div style={{display: 'flex', flexDirection: 'row', maxWidth: 1500, width: '100%', height: '100%',  color: 'white', justifyContent: 'space-between', alignItems: 'center'}}>
                    <div style={{maxWidth: '50%', height: '100%', width: 300, position: 'relative', padding: windowSize.width > 900 ? 30 : 10, display: 'flex', alignItems: 'center'}}>
                        <img src={logotrans} alt="logo"
                             style={{filter: 'invert(0)', width: 'auto', height: windowSize.width > 900 ? '70%' : '70%', //flex: 1,
                               // backgroundColor: 'rgba(255,255,255,0.1)', boxShadow: '0px 0px 10px 10px rgba(255,255,255,0.1)'
                             }}/>
                    </div>
                    {windowSize.width > 900 ? (
                        <div style={{
                            fontSize: 20,
                            fontWeight: 100,
                            letterSpacing: 2,
                            display: 'flex',
                            flexDirection: 'row',
                            padding: 30,
                            width: '100%',
                            height: '100%',
                            maxWidth: 500,
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}>
                            <div className={'mouseover'}
                                 onClick={() => {
                                     window.scrollTo({top: 0, behavior: 'smooth'});
                                 }}
                            >
                                Hem
                            </div>
                            <div className={'mouseover'}
                                 onClick={() => {
                                     scroll('sell')
                                 }}
                            >
                                Sälj
                            </div>
                            <div className={'mouseover'}
                                 onClick={() => {
                                     scroll('buy')
                                 }}
                            >
                                Köp
                            </div>
                            <div className={'mouseover'}
                                 onClick={() => {
                                     scroll('pay')
                                 }}
                            >
                                Betalning
                            </div>
                            <div className={'mouseover'}
                                 onClick={() => {
                                     scroll('contact')
                                 }}
                            >
                                Kontakt
                            </div>
                            <div className={'mouseover'}
                                 onClick={() => {
                                     scroll('about')
                                 }}
                            >
                                Om
                            </div>
                        </div>
                    ) : (
                        <div style={{
                            position: 'fixed',
                            bottom: 0,
                            left: 0,
                            height: 60,
                            width: '100%',
                            backgroundColor: 'rgba(30,30,30, 0.99)',
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-around',
                            alignItems: 'center',
                            boxShadow: '0px 1px 20px -5px #0092C8'
                        }}>
                            <img className={'mouseover'} src={homeicon}
                                 style={{filter: 'invert(0.7)', width: 30, height: 30}} onClick={() => scroll('home')}/>
                            <img className={'mouseover'} src={sell}
                                 style={{filter: 'invert(0.7)', width: 30, height: 30}} onClick={() => scroll('sell')}/>
                            <img className={'mouseover'} src={buy}
                                 style={{filter: 'invert(0.7)', width: 30, height: 30}} onClick={() => scroll('buy')}/>
                            <img className={'mouseover'} src={bank}
                                 style={{filter: 'invert(0.7)', width: 30, height: 30}} onClick={() => scroll('pay')}/>
                            <img className={'mouseover'} src={contact}
                                 style={{filter: 'invert(0.7)', width: 30, height: 30}}
                                 onClick={() => scroll('contact')}/>
                            <img className={'mouseover'} src={about}
                                 style={{filter: 'invert(0.7)', width: 30, height: 30}}
                                 onClick={() => scroll('about')}/>

                        </div>

                    )}
                    <div style={{
                        marginRight: windowSize.width > 900 ? 0 : 10,
                        justifyContent: 'end',flex: 1, display: 'flex', flexDirection: 'row', height: '100%', width: 'auto', padding: windowSize.width > 900 ? 30 : 0, alignItems: 'center'}}>
                        <img className={'mouseover'}
                             src={instagram}
                             alt="logo"
                             style={{width: 'auto', height: '40%', marginRight: 20}}
                            onClick={()=>{
                                window.location.href = 'https://www.instagram.com/wetterstadensbilab/';
                            }}
                        />
                        <img className={'mouseover'}
                             src={facebook}
                             alt="logo"
                             style={{width: 'auto', height: '40%', }}
                             onClick={()=>{
                                 window.location.href = 'https://www.facebook.com/wetterstadensbilab/'
                             }}
                        />
                    </div>
                </div>
            </div>

            <div id={'home'} style={{position: 'relative', height: windowSize.width > 900 ? height - 80 - 200 : height - 20, maxHeight: windowSize.height-100}}>
                <div style={{flexDirection: 'column', position: 'fixed', top: windowSize.width > 900 ? -200 : 0, left: 0, backgroundColor: 'rgba(0,0,0, .9)', color: 'red', width: '100%', height: '80vh', zIndex: -2, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>

                    {images.map((image, index)=>{
                        return (
                            <img ref={frontref}
                                 src={image}
                                 key={index}
                                 alt="car"
                                 className={index === number ? 'frontid' : 'frontidout'}
                                 style={{display: index === number ? 'flex':'flex', width: '100%', height: 'auto', position: 'absolute', top: 70, left: 0}}
                            />
                        )
                    })}

                </div>
            </div>

            <div style={{
                backgroundColor: 'rgba(27,27,27, 1)',
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column'
            }}>
                <div id={'sell'} className={'rutor'}
                     style={{backgroundColor: 'rgba(0,0,0,.2)', display: 'flex', flexDirection: 'row', padding: 30, width: '100%'}}>
                    <div style={{display: 'flex', flexDirection: 'column', width: '50%', padding: 50}}>
                        <div style={{color: '#0092C8', fontSize: 12, letterSpacing: 5}}>
                            Wetterstadens Bil
                        </div>
                        <div style={{color: 'white', fontSize: 30, marginTop: 20}}>
                            Sälj ditt Fordon
                        </div>
                        <div style={{
                            fontSize: 16,
                            width: '100%',
                            marginTop: 15,
                            maxWidth: 500,
                            color: 'white',
                            lineHeight: 2
                        }}>
                            Hos oss kan du både sälja och byta in din bil på ett enkelt och smidigt sätt. Oavsett om du
                            är ute efter att byta till en nyare modell eller vill sälja din bil direkt, hjälper vi dig
                            hela vägen. Våra erfarna försäljare gör en snabb och rättvis värdering av din bil och ger
                            dig ett konkurrenskraftigt erbjudande. Vi strävar efter att göra processen så trygg och
                            bekväm som möjligt för dig, med personligt bemötande och tydlig information. Kom förbi oss
                            eller kontakta oss för en kostnadsfri offert – vi ser fram emot att hjälpa dig med din
                            bilaffär!
                        </div>
                    </div>
                    {windowSize.width > 900 ? <img src={sellcar} style={{width: '40%', padding: 30}}/> : null}
                </div>

                <div id={'buy'} className={'rutor'} style={{
                    width: '100%',
                    //backgroundColor: 'rgba(0,0,0,.2)',
                    display: 'flex',
                    flexDirection: 'row',
                    padding: 30
                }}>
                    {windowSize.width > 900 ? <img src={buycar} style={{width: '40%', padding: 30}}/> : null}
                    <div style={{display: 'flex', flexDirection: 'column', width: '50%', padding: 50}}>
                        <div style={{color: '#0092C8', fontSize: 12, letterSpacing: 5}}>
                            Wetterstadens Bil
                        </div>
                        <div style={{color: 'white', fontSize: 30, marginTop: 20}}>
                            Fordon i lager
                        </div>
                        <div style={{
                            fontSize: 16,
                            width: '100%',
                            marginTop: 15,
                            maxWidth: 500,
                            color: 'white',
                            lineHeight: 2
                        }}>
                            Vi erbjuder finansiering via Santander, LF Finans, Svea & My Money.
                            Vi erbjuder garantier upp till 36 mån.
                            <br/>
                            Vi har 25 års samlad erfarenhet från fordonsbranchen.
                            Vårt mål är att erbjuda fordon med bra historik till marknadens bästa priser. För att kunna
                            erbjuda bästa service vill vi att ni ringer och bokar tid.
                            Vi erbjuder även hemkörning av alla bilar. Vi har fasta priser till alla städer i Sverige.
                        </div>
                        <div style={{
                            alignSelf: 'center',
                            fontWeight: 500,
                            letterSpacing: 2,
                            fontSize: 16,
                            marginTop: 40,
                            width: "auto",
                            cursor: 'pointer',
                            backgroundColor: '#0092C8',
                            color: 'white',
                            padding: 20,
                            paddingLeft: 20,
                            paddingRight: 20,
                            borderRadius: 10,
                            boxShadow: '0px 1px 20px 1px #0092C8'
                        }}
                             className={'mouseover'}
                             onClick={() => {
                                 window.location.href = 'https://www.blocket.se/butik/wetterstadens-bil';
                             }}
                        >
                            Se begagnade bilar i lager ⭧
                        </div>
                    </div>
                </div>

                <div id={'pay'} className={'rutor'} style={{
                    width: '100%',
                    backgroundColor: 'rgba(0,0,0,.2)',
                    display: 'flex',
                    flexDirection: 'row',
                    padding: 30
                }}>

                    <div style={{display: 'flex', flexDirection: 'column', width: '50%', padding: 50}}>
                        <div style={{color: '#0092C8', fontSize: 12, letterSpacing: 5}}>
                            Wetterstadens Bil
                        </div>
                        <div style={{color: 'white', fontSize: 30, marginTop: 20}}>
                            Betalning
                        </div>
                        <div style={{
                            fontSize: 16,
                            width: '100%',
                            marginTop: 15,
                            maxWidth: 500,
                            color: 'white',
                            lineHeight: 2
                        }}>
                            För er och vår säkerhet har vi kontantlös betalning. Det går endast att betala via Swish: 1234-737821 eller banköverföring. Swish går att höja gränsen på de flesta banker till 150.000:-
                            <br/>
                            Banköverföring sker till vårt konto i Handelsbanken: 6641 - 577 164 422. Märk med namn. Betalning via överföring måste genomföras 2 dagar innan leverans.
                        </div>
                    </div>
                    {windowSize.width > 900 ? <img src={swish} style={{width: '40%', padding: 30}}/> : null}
                </div>

                <div id={'contact'} className={'rutor'} style={{
                    width: '100%',
                    //backgroundColor: 'rgba(0,0,0,.2)',
                    display: 'flex',
                    flexDirection: 'row',
                    padding: 30
                }}>
                    <div style={{
                        overflow: 'hidden',
                        height: windowSize.width > 900 ? '' : 400,
                        width: '40%',
                        borderRadius: '20px',
                        marginRight: windowSize.width > 900 ? 40 : 0,
                        minHeight: 400

                    }}>
                        <iframe width="100%" height="100%" id="gmap_canvas" title="googleMap"
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d8479.716855978604!2d14.064253675582142!3d57.90431546232655!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x465a688bf8dc6475%3A0x1e44def7033141f2!2zSsO2bmvDtnBpbmdzdsOkZ2VuIDI4LCA1NjYgMzEgSGFibw!5e0!3m2!1ssv!2sse!4v1757880617526!5m2!1ssv!2sse"
                            //width="600" height="450"
                            //style="border:0;"
                                allowFullScreen=""
                            //loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                                frameBorder="0" scrolling="no" marginHeight="0" marginWidth="0">
                        </iframe>
                        <a href="https://www.whatismyip-address.com/divi-discount/"></a><a
                        href="https://www.embedgooglemap.net"></a>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'column', width: '50%', padding: 50}}>
                        <div style={{color: '#0092C8', fontSize: 12, letterSpacing: 5}}>
                            Wetterstadens Bil
                        </div>
                        <div style={{color: 'white', fontSize: 30, marginTop: 20}}>
                            Kontakt
                        </div>
                        <div style={{
                            fontSize: 16,
                            width: '100%',
                            marginTop: 15,
                            maxWidth: 500,
                            color: 'white',
                            lineHeight: 2
                        }}>
                            För att säkerställa att fordonet ni är intresserad av finns kvar, rekommenderar vi att ni
                            ringer eller mailar innan besök.
                        </div>
                        <a href={'tel:036165452'}
                           style={{width: 250, display: 'flex', flexDirection: 'row', marginTop: 20}}>
                            <img src={contact} style={{filter: 'invert(1)', width: 35, height: 35, marginRight: 15}}/>
                            <div className={'mouseover'} style={{color: 'white', alignSelf: 'center'}}>
                                036 - 16 54 52
                            </div>
                        </a>
                        <a href={'mailto:info@wetterstadensbil.se'}
                           style={{width: 250, display: 'flex', flexDirection: 'row', marginTop: 10}}>
                            <img src={email} style={{filter: 'invert(1)', width: 35, height: 35, marginRight: 15}}/>
                            <div className={'mouseover'} style={{color: 'white', alignSelf: 'center'}}>
                                info@wetterstadensbil.se
                            </div>
                        </a>
                        <a href={'https://maps.app.goo.gl/dWKPQgU6FJgGZRk18'}
                           style={{width: 250, display: 'flex', flexDirection: 'row', marginTop: 10}}>
                            <img src={homeicon} style={{filter: 'invert(1)', width: 35, height: 35, marginRight: 15}}/>
                            <div className={'mouseover'}
                                 style={{display: 'flex', flexDirection: 'column', color: 'white'}}>
                                <div>
                                    Jönköpingsvägen 28
                                </div>
                                <div>
                                    566 31 Habo
                                </div>
                            </div>
                        </a>
                    </div>

                </div>

                <div id={'about'} className={'rutor'} style={{
                    width: '100%',
                    backgroundColor: 'rgba(0,0,0,.2)',
                    display: 'flex',
                    flexDirection: 'row',
                    padding: 30
                }}>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: `100% ${" !important"}`,
                        padding: 50,
                        textAlign: 'center',
                        alignItems: 'center'
                    }}>
                        <div style={{color: '#0092C8', fontSize: 12, letterSpacing: 5}}>
                            Wetterstadens Bil
                        </div>
                        <div style={{color: 'white', fontSize: 30, marginTop: 20, maxWidth: 800}}>
                            ETT FAMILJÄRT FÖRETAG MED 25 ÅRS ERFARENHET FRÅN FORDONSBRANSCHEN
                        </div>
                        <div style={{
                            fontSize: 16,
                            width: '100%',
                            marginTop: 15,
                            color: 'white',
                            lineHeight: 2,
                            maxWidth: 800,
                            textAlign: 'left'
                        }}>
                            Vi erbjuder fordon med bra historik till marknadens bästa priser.
                            <br/>
                            Finansiering: Möjligheter till finansiering finns. Vi hjälper dig att skräddarsy ditt
                            upplägg.
                            Vi samarbetar med Santander, LF Finans, Svea Ekonomi och My Money med 0:- insats.
                            <br/>
                            Försäkring: Via samarbete med Länsförsäkringar erbjuder vi 1 månads gratis
                            prova-på-försäkring när du köper bil hos oss.
                            Garanti: För extra trygghet erbjuder vi våra kunder garanti som kan tecknas upp till 24
                            månader genom vår samarbetspartner Svensk Bilgaranti/Fragus.
                            <br/>
                            Vi byter gärna in din personbil, MC, mopedbil, lätt lastbil eller båt.
                            Vi finns på Jönköpingsvägen 28 i Habo strax utanför Jönköping.
                            <br/>
                            Vi har öppet Måndag-Lördag. Söndagar och röda dagar enligt ö.k.
                            <br/>
                            Välkomna till Joacim, Pierre & Mikael på Wetterstadens Bil!
                        </div>
                    </div>
                </div>

                <div style={{
                    padding: 20,
                    display: 'flex',
                    flexDirection: windowSize.width > 900 ? 'row' : 'column',
                    justifyContent: windowSize.width > 900 ? 'space-between' : 'center',
                    alignItems: windowSize.width > 900 ? null : 'center',
                    width: '100%',
                    backgroundColor: 'rgba(27,27,27, 1)',
                    color: 'white',
                    minHeight: 300,
                    maxWidth: 1600,
                    paddingBottom: windowSize.width > 900 ? 20 : 0
                }}>
                    <div className={'footer'}
                         style={{padding: 40, display: 'flex', flex: '1 1 0%', flexDirection: 'column'}}>
                        <img src={logotrans}
                             style={{
                                 width: 200, height: 'auto', alignSelf: 'start',
                                 //backgroundColor: 'rgba(255,255,255,0.05)', boxShadow: '0px 0px 20px 15px rgba(255,255,255,0.05)'
                             }}/>
                        <div style={{marginTop: 20, maxWidth: 300}}>
                            Hos oss hittar du inte bara en bil, du hittar din nästa bil.
                            Din lokala bilhandlaree
                        </div>
                        <Policy/>
                    </div>
                    <div className={'footer'}
                         style={{padding: 40, display: 'flex', flex: '1 1 0%', flexDirection: 'column'}}>
                        <div style={{fontSize: 20, letterSpacing: 2, fontWeight: 400}}>
                            Kontakt
                        </div>
                        <a href={'tel:036165452'}
                           style={{display: 'flex', flexDirection: 'row', marginTop: windowSize.width > 900 ? 30 : 15}}

                        >
                            <div style={{marginRight: 20}}>
                                Telefon:
                            </div>
                            <div style={{color: 'white'}}
                                 className={'mouseover'}
                            >
                                036 - 16 54 52
                            </div>
                        </a>
                        <a href={'mailto:info@wetterstadensbil.se'}
                           style={{display: 'flex', flexDirection: 'row', marginTop: 15}}>
                            <div style={{marginRight: 40}}>
                                Mail:
                            </div>
                            <div style={{color: 'white'}}
                                 className={'mouseover'}
                            >
                                info@wetterstadensbil.se
                            </div>
                        </a>
                        <a href={'https://maps.app.goo.gl/dWKPQgU6FJgGZRk18'}
                           style={{display: 'flex', flexDirection: 'row', marginTop: 15}}>
                            <div style={{marginRight: 15}}>
                                Address:
                            </div>
                            <div className={'mouseover'}
                                 style={{display: 'flex', flexDirection: 'column', color: 'white'}}>
                                <div>
                                    Jönköpingsvägen 28
                                </div>
                                <div>
                                    566 31 Habo
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className={'footer'} style={{
                        padding: 40,
                        display: 'flex',
                        flex: '1 1 0%',
                        flexDirection: 'column',
                        alignItems: 'left'
                    }}>
                        <div style={{fontSize: 20, fontWeight: 400, letterSpacing: 2}}>
                            Öppetider
                        </div>
                        <div style={{marginTop: windowSize.width > 900 ? 30 : 15}}>
                            <div style={{display: 'flex', flexDirection: 'row'}}>
                                <div>Måndag-Torsdag:</div>
                                <div style={{marginLeft: 10}}>10:00 - 18:00</div>
                            </div>
                            <div style={{display: 'flex', flexDirection: 'row', marginTop: 15}}>
                                <div>Fredag:</div>
                                <div style={{marginLeft: 82}}>10:00 - 17:00</div>
                            </div>
                            <div style={{display: 'flex', flexDirection: 'row', marginTop: 15}}>
                                <div>Lördag:</div>
                                <div style={{marginLeft: 82}}>10:00 - 13:00 (tidsbokning)</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={'rutor'}
                     style={{
                         color: 'white',
                         marginBottom: windowSize.width > 900 ? 20 : 100,
                         alignSelf: 'center',
                         textAlign: windowSize.width > 900 ? 'left' : 'center',
                         fontSize: windowSize.width > 900 ? 14 : 12
                     }}>
                    Copyright © 2025 All rights reserved | Wetterstadens Bil
                </div>
            </div>
        </div>
    );
}

export default App;
/*
<div style={{color: '#0092C8', fontSize: 12, letterSpacing: 5}}>
                            Wetterstadens Bil
                        </div>
 */